<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="flex flex-col bg-base-200 rounded-md p-4">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: "WidgetComponent"
};
</script>

<style scoped>

</style>